export const GET_TRANSACTION = 'CITIZEN/get_transaction';
export const APPROVE_TRANSACTION = 'CITIZEN/approve_transaction';
export const UPDATE_TRANSACTION = 'CITIZEN/update_transaction';
export const SHOW_TRANSACTION = 'CITIZEN/show_transaction';
export const START_ASSESSMENT = 'CITIZEN/start_assessment';
export const GET_SETTINGS = 'CITIZEN/get_settings';
export const UPDATE_TEST_STATUS = 'CITIZEN/update_health_status';
export const GET_BIRTH_ARCHIVE = 'CITIZEN/get_birth_certificates_arhive';
export const GET_BIRTH_CERTIFICATE = 'CITIZEN/get_birth_certificates';
export const ACTIVATE_PROFILE = 'CITIZEN/activate_profile';
export const UPDATE_PROFILE = 'CITIZEN/update_profile';
export const CHANGE_PASSWORD = 'CITIZEN/change_password';
export const CREATE_ACCOUNT = 'CITIZEN/create_account';

export const CHANGE_PIN = 'CITIZEN/change_pin';
export const VALIDATE_OTP = 'CITIZEN/validate_otp';
export const RESEND_OTP = 'CITIZEN/resend_otp';

export const UPDATE_VALIDATE_OTP = 'CITIZEN/update_validate_otp';
export const RESEND_UPDATE_VALIDATE_OTP = 'CITIZEN/resend_update_validate_otp';

export const GET_TRANSACTIONS = 'CITIZEN/get_transactions';

export const DEPENDENCIES = {
  health_certificate_amount: {
    label: 'Health Certificate',
  },
  occupational_permit_amount: {
    label: 'Occupational Permit',
  },
  card_type: {
    label: 'CARD TYPE',
  },
  stool_amount: {
    label: 'Stool',
  },
  sputum_amount: {
    label: 'Sputum',
  },
  drug_test_amount: {
    label: 'Drug Test',
  },
  rpr_syphilis_amount: {
    label: 'RPR Syphilis',
  },
  gram_stain: {
    label: 'Gram Stain',
  },
};

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
  first_name: '',
  last_name: '',
  middle_name: '',
  mothers_first_name: '',
  mothers_middle_name: '',
  mobile_number: '',
  mothers_last_name: '',
  birth_date: '',
  photo: '',
  user_id: '',
  is_user_id_auth: 0,
};

export const GET_REGION = 'CITIZEN/get_regions';
export const GET_PROVINCE = 'CITIZEN/get_provinces';
export const GET_MUNICIPALITIES = 'CITIZEN/get_municipalities';
export const GET_BARANGAYS = 'CITIZEN/get_barangays';

export const CIVIL_STATUSES = [
  {
    label: 'SINGLE',
    value: 'SINGLE',
  },
  {
    label: 'MARRIED',
    value: 'MARRIED',
  },
  {
    label: 'DIVORCED',
    value: 'DIVORCED',
  },
  {
    label: 'WIDOW',
    value: 'WIDOW',
  },
];

export const GENDERS = [
  { label: 'FEMALE', value: 'FEMALE' },
  { label: 'MALE', value: 'MALE' },
];

export const EXTENSION_NAMES = [
  { label: 'N/A', value: '' },
  { label: 'JR.', value: 'JR.' },
  { label: 'SR.', value: 'SR.' },
  { label: 'II', value: 'II' },
  { label: 'III', value: 'III' },
  { label: 'IV', value: 'IV' },
  { label: 'V', value: 'V' },
  { label: 'VI', value: 'VI' },
  { label: 'VII', value: 'VII' },
  { label: 'VIII', value: 'VIII' },
  { label: 'IX', value: 'IX' },
  { label: 'X', value: 'X' },
];

export const PERMIT_TYPES_LABELS = {
  rpt: 'Real Property Tax (RPTAX)',
  btax: 'Business Tax (BTAX)',
  ohp: 'Occupational Permit / Health Certificate',
  nov: 'NOV - Notice of Violation',
  ovrs: 'OVR - Ordinance Violation Receipt System',
  civilRegistry: 'Local Civil Registry',
  bpls: 'Business Permit Application (NEW & RENEWAL)',
  cdl: 'Community Tax Certificate CTC / CEDULA',
}
